import React from 'react';
import pull = require("lodash/pull");
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton';
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import {createForm, fieldStyles} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {MdIconButton} from "core/components/buttons/icons";
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import Add from "material-ui/svg-icons/content/add";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {observer} from "mobx-react";
import {Party, Address, ADDRESSTYPE, PARTYROLE} from "party/partyDomain";
import {ObservableMap, action, observable} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {FormProps, ClosedContentProps, lovValue, IDomainObject, FieldText} from "core/form/formUtils";
import partyService from "party/partyService";
import {GOOGLE_API_KEY} from "core/common/config/variables";
import * as Colors from "material-ui/styles/colors";
import {optionsSearch} from "../../core/common/service/commonDataService";
import PropTypes from "prop-types";


interface PartyAddressListProps {
  partyObject: Party;
  entities: ObservableMap<MdEntity>;
}

@observer
export default class PartyAddressList extends React.Component<PartyAddressListProps, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  @action addAddress = () => {
    console.debug('addAddress');
    const {partyObject, entities} = this.props;
    let newAddress = new Address({$new: true, $added: true}).initDefaultValues();
    partyObject.addresses.push(newAddress);
    partyObject.$dirty = true;
  };




  render() {

    const {partyObject, entities} = this.props;

    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>Addresses</div>
        <MdIconButton onClick={this.addAddress}>
          <Add />
        </MdIconButton>
      </div>
    );

    return (
      <BlockComp header={header} noPadding={true} style={{display: 'flex', flexDirection: 'column'}}>

        {
          addSeparator( partyObject.addresses.map((address, index) => <AddressForm dataObject={address}
                                                                                 rootObject={partyObject}
                                                                                 key={index}
                                                                                 entities={entities}
                                                                                 entity={entities.get('Address')}
                                                                                 index={index}/>), <MdDivider inset={true}/>)
        }



      </BlockComp>
    );
  }
}


interface AddressClosedContentProps extends ClosedContentProps<Address> {
  openMap: (evt) => void;
}

const ClosedContent = ({dataObject, entity, entities, fields, openMap}: AddressClosedContentProps) => {

  const fontIconStyle: any = {fontSize: 16};
  const otherPar: any = {};

  if (dataObject.placeId) {
    fontIconStyle.fontWeight = "bold";
    fontIconStyle.cursor = "pointer";
    otherPar.onClick = openMap
  }

  return (
    <div style={{display: 'flex', fontSize: 14, lineHeight: '14px'}}>
      <FontIcon className="fa fa-envelope-o"
                color={!dataObject.active ? '#666' : (dataObject.addressType) ? Colors[dataObject.addressType["color"]] : null}
                style={fontIconStyle} {...otherPar}/>
      <div style={{display: 'flex', flexDirection: 'column', marginLeft: 20}} className={!dataObject.active? "text-thru" : ""}>
        {(dataObject.name) ? <div>{dataObject.name}</div> : ''}
        <div style={(dataObject.name) ? {marginTop: 5} : {}}>{dataObject.addressLine()}</div>
        {(dataObject.toHands || dataObject.comment) ? (
          <div style={{fontSize: 12, color: Colors.grey500, marginTop: 2}}>
            {[((dataObject.toHands) ? ('To hands: ' + dataObject.toHands) : ''), dataObject.comment].filter(v => v).join(', ')}
          </div>) : ''}
          <div className="form-text-row">
            <FieldText label={fields.ftlEscalationMinutes.textLabel} value={dataObject.ftlEscalationMinutes} style={{marginTop: '10px'}}/>
            <FieldText label={fields.ltlEscalationMinutes.textLabel} value={dataObject.ltlEscalationMinutes} style={{marginTop: '10px'}} />
          </div>
          <div className="form-text-row">
            <FieldText label={fields.defaultDisponentParty.textLabel} value={dataObject.defaultDisponentParty} style={{marginTop: '10px'}}/>
          </div>
      </div>
    </div>
  )
};


@createForm({
  formName: 'AddressForm',
  fields: [{
    name: 'addressType',
    validators: ['IsRequired']
  }, {
    name: 'name'
  }, {
    name: 'toHands'
  }, {
    name: 'street'
  }, {
    name: 'descriptiveNumber'
  }, {
    name: 'orientationalNumber'
  }, {
    name: 'city',
    validators: ['IsRequired']
  }, {
    name: 'administrativeArea'
  }, {
    name: 'zip'
  }, {
    name: 'country'
  }, {
    name: 'comment'
  }, {
    name: 'ftlEscalationMinutes',
    validators: ['IsNumber', {validation: 'Max', parameters: {max: 999}}, {validation: 'Min', parameters: {min: 1}}]
  }, {
    name: 'ltlEscalationMinutes',
    validators: ['IsNumber', {validation: 'Max', parameters: {max: 999}}, {validation: 'Min', parameters: {min: 1}}]
  }, {
    name: 'defaultDisponentParty'
  }, {
    name: 'active'
  }]
}, ClosedContent)
@observer
class AddressForm extends React.Component<FormProps<Address, Party>, undefined> {

  @observable
  private showMap: boolean;

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.addresses, this.props.dataObject);
  };

  @action updateFromRegister = (evt) => {
    let {dataObject, rootObject, form} = this.props;
    console.log('updateFromRegister');
    partyService.partyVatIdDownload({vatId: rootObject.dic, nationality: lovValue(rootObject.nationality), language: lovValue(rootObject.defaultLanguage)})
      .then(action("partyVatIdDownload-actionCb", (json: IDomainObject) => {
        if (json) {
          dataObject.cleanAfterSave(json, true, "addressId", "comment", "party");
          form.updateAllFieldsPropValue(dataObject);
          dataObject.$dirty = true; rootObject.$dirty = true;
        }
      }));
  };

  @action reparse = (evt) => {
    let {dataObject,rootObject, form} = this.props;
    console.log('reparse');
    let nationality = lovValue(dataObject.country);
    nationality = (nationality) ? nationality : lovValue(rootObject.nationality);
    partyService.addressParse({addressLine: dataObject.addressLine(), nationality, language: lovValue(rootObject.defaultLanguage)})
      .then(action("addressParse-actionCb", (json: IDomainObject) => {
        if (json) {
          dataObject.cleanAfterSave(json, true, "addressId", "comment", "name", "party", "addressType");
          form.updateAllFieldsPropValue(dataObject);
          dataObject.$dirty = true; rootObject.$dirty = true;
        }
      }));
  };

  @action openMap = (evt) => {
    let {dataObject,rootObject, form} = this.props;
    console.log('openMap');
    this.showMap = !this.showMap;
  };

  render() {

    const {dataObject, rootObject, index, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {addressType, name, street, toHands, descriptiveNumber, orientationalNumber, city, zip, comment, country, administrativeArea, ftlEscalationMinutes, ltlEscalationMinutes, defaultDisponentParty, active} = fields;

    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-4">
            <StyledSelect {...addressType.props}/>
            <Validate field={addressType} value={addressType.props.value}/>
          </div>
          <div className="fx col-xs-4">
            <MdTextField {...name.props} />
          </div>
          <div className="fx col-xs-4">
            <MdTextField {...toHands.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-4">
            <MdTextField {...street.props}/>
            <Validate field={street} value={street.props.value}/>
          </div>
          <div className="fx col-xs-2">
            <MdTextField {...descriptiveNumber.props} />
          </div>
          <div className="fx col-xs-2">
            <MdTextField {...orientationalNumber.props} />
          </div>
          <div className="fx col-xs-2">
            <MdTextField {...city.props} />
            <Validate field={city} value={city.props.value}/>
          </div>
          <div className="fx col-xs-2">
            <MdTextField {...zip.props} />
            <Validate field={zip} value={zip.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-3">
            <StyledSelect {...country.props} />
          </div>
          <div className="fx col-xs-4">
            <MdTextField {...administrativeArea.props}/>
          </div>
          <div className="fx col-xs-5">
            <MdTextField {...comment.props}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6">
            <MdTextField {...ftlEscalationMinutes.props} />
            <Validate field={ftlEscalationMinutes} value={ftlEscalationMinutes.props.value}/>
          </div>
          <div className="fx col-xs-6">
            <MdTextField {...ltlEscalationMinutes.props}/>
            <Validate field={ltlEscalationMinutes} value={ltlEscalationMinutes.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-10">
            <StyledSelect  {...defaultDisponentParty.props} async={true}
                           loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CONTACT_ROLE], disponent: true})}
                           clearable={true}/>
            <Validate field={defaultDisponentParty} value={defaultDisponentParty.props.value}/>
          </div>
          <div className="fx col-xs-2">
            <MdCheckbox {...active.props} style={{alignSelf: 'center'}}/>
            <Validate field={active} value={active.props.value}/>
          </div>
        </div>
      </div>
    );

    const openButtons = (
      <div>
        {(lovValue(dataObject.addressType) === ADDRESSTYPE.PERMANENT && rootObject.dic) ? <FlatButton label="Update from EU register" primary onClick={this.updateFromRegister}/> : null}
        <FlatButton label="Reparse" primary onClick={this.reparse}/>
      </div>
    );

    return (
      <div>
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields, openMap: this.openMap}} />} key={index}
                    onDelete={this.onDelete}  validate={this.props.validate} openButtons={openButtons} {...this.props} />


        { (this.showMap) ? (
          <iframe width="100%"
                  height="450"
                  frameBorder="0"
                  style={{border: 0, paddingLeft: 20, paddingRight: 20}}
                  src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_API_KEY}&q=place_id:${dataObject.placeId}`} allowFullScreen={true}>
          </iframe>
        ) : null}

      </div>
    );
  }
}






// WEBPACK FOOTER //
// ./src/party/component/partyAddressList.tsx